import React, { useState } from 'react';
import styled from 'styled-components';
import { Grid, Logo } from '../atoms';

import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userSelector } from '../../state';
import { useTranslation } from 'react-i18next';
import { Image } from 'primereact/image';

interface CustomMenuProps {
    className?: string | undefined;
}


export const CustomMenu: React.FC<CustomMenuProps> = (props) => {

    const {t} = useTranslation();
    let user = useSelector(userSelector).singleItem;
    const [expandedKeys, setExpandedKeys] = useState({});
    const [showSettings, setShowSettings] = useState(false);

    let navigation = useNavigate();

    function toggleShowSettings() {
        setShowSettings(!showSettings);
    }

    const itemRenderer = (item: any) => (

        <Menu model={items2} className="mt-6" style={{border: 'none'}}/>
    );
    let items = [
        {
            items: [
                {
                    label: 'Wallets',
                    icon: <Grid className="mr-2 flex"/>,
                    command: () => {
                        navigation('/wallets');
                    },
                    className: 'mb-3'
                },
                {
                    label: 'Demo credentials',
                    icon: <i className="pi pi-list mr-2 flex"/>,
                    command: () => {
                        navigation('/demo-credentials-list');
                    },
                    className: 'mb-3'
                }
            ],
            className: 'text-gray-900'
        }
    ];

    const items2 = [
        {
            label: 'New', icon: 'pi pi-fw pi-plus', command: () => {
                navigation('/did');
            }
        },
        {
            label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => {
                navigation('/did');
            }
        }
    ]

    return (
        <div className={"h-full " + props.className}>
        <div className={"flex flex-column h-full mt-4"}>
            <div className="flex flex-row justify-content-center cursor-pointer" onClick={event => navigation('/')}>
                {(user?.base64EncodedOrganizationLogo === undefined) && (
                    <Logo className="flex align-self-start"/>
                )}
                {(user?.base64EncodedOrganizationLogo !== undefined) && (
                    <Image src={user?.base64EncodedOrganizationLogo} alt="Logo" width="120"/>
                )}
            </div>
            <Menu model={items} className="mt-3 mr-0" style={{border: 'none'}}/>

            <div className="flex flex-column justify-content-end align-items-center flex-grow-1 pb-2 mb-4" style={{height: '100%'}}>
                <div className="text-sm mt-6 mb-2" style={{color: 'var(--black-200)'}}>Powered by:</div>
                <Logo/>
            </div>
        </div>
        </div>
    );
};

const Root = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 20px 16px 16px;
    height: 100%;
`;

const MenuItem = styled.div`
    padding-top: 20px;
`;

